import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    CircularProgress,
    LinearProgress,
    Stack,
    Typography,
    useTheme,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { FitnessCenterRounded, PlaceRounded } from "@mui/icons-material";
import {
    Report_corporatePopularPlaces,
    Report_corporatePopularSports,
} from "../../../network/api/report.api";

const _DashPopularSportsAndPlaces = ({ corporateId }) => {
    const theme = useTheme();
    const [sports, setSports] = useState([]);
    const [places, setPlaces] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!corporateId) return;
        setLoading(true);
        Promise.all([
            Report_corporatePopularSports(corporateId).catch(() => null),
            Report_corporatePopularPlaces(corporateId).catch(() => null),
        ])
            .then(([resS, resP]) => {
                setSports(resS?.data?.Data?.Rows || []);
                setPlaces(resP?.data?.Data?.Rows || []);
            })
            .finally(() => setLoading(false));
    }, [corporateId]);

    const renderList = (items, defaultColor, icon) => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200 }}>
                    <CircularProgress size={26} />
                </Box>
            );
        }
        if (items.length === 0) {
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 200 }}>
                    <Typography variant="caption" color="text.secondary">داده‌ای ثبت نشده است.</Typography>
                </Box>
            );
        }
        return (
            <Stack spacing={1.6} sx={{ my: 'auto' }}>
                {items.map((item, idx) => (
                    <Box key={idx}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.5 }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box
                                    sx={{
                                        width: 22,
                                        height: 22,
                                        borderRadius: '50%',
                                        bgcolor: idx < 3 ? defaultColor : 'action.selected',
                                        color: idx < 3 ? '#fff' : 'text.secondary',
                                        fontSize: '0.7rem',
                                        fontWeight: 800,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    {idx + 1}
                                </Box>
                                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                    {item.Label}
                                </Typography>
                            </Box>
                            <Typography variant="caption" sx={{ fontWeight: 800, color: 'text.secondary' }}>
                                {item.Percent || 0}٪
                            </Typography>
                        </Box>
                        <LinearProgress
                            variant="determinate"
                            value={item.Percent || 0}
                            sx={{
                                height: 7,
                                borderRadius: 4,
                                bgcolor: 'action.hover',
                                '& .MuiLinearProgress-bar': {
                                    bgcolor: defaultColor,
                                    borderRadius: 4,
                                },
                            }}
                        />
                    </Box>
                ))}
            </Stack>
        );
    };

    return (
        <Card
            elevation={0}
            sx={{
                p: { xs: 2, sm: 2.5 },
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <Grid container spacing={3} sx={{ height: '100%' }}>
                {/* ورزش‌های پرطرفدار */}
                <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 2 }}>
                        <Box
                            sx={{
                                width: 38,
                                height: 38,
                                borderRadius: 2.5,
                                bgcolor: 'rgba(45, 107, 226, 0.1)',
                                color: 'primary.main',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <FitnessCenterRounded sx={{ fontSize: 20 }} />
                        </Box>
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                                رشته‌های ورزشی پرطرفدار
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                درصد استقبال پرسنل به تفکیک رشته‌ها
                            </Typography>
                        </Box>
                    </Box>
                    {renderList(sports, theme.palette.primary.main)}
                </Grid>

                {/* مراکز پربازدید */}
                <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2, mb: 2 }}>
                        <Box
                            sx={{
                                width: 38,
                                height: 38,
                                borderRadius: 2.5,
                                bgcolor: 'rgba(0, 137, 123, 0.1)',
                                color: '#00897b',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <PlaceRounded sx={{ fontSize: 20 }} />
                        </Box>
                        <Box>
                            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                                مجموعه‌های پربازدید پرسنل
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                باشگاه‌ها و مراکز ورزشی با بیشترین مراجعه
                            </Typography>
                        </Box>
                    </Box>
                    {renderList(places, '#00897b')}
                </Grid>
            </Grid>
        </Card>
    );
};

export default _DashPopularSportsAndPlaces;
